import React, { useEffect, useState } from 'react'
import HomepageSectionHero from '../../types/pages/homepage/section/hero'
import Logo from '../images/logo.svg'
import { Image, Modal } from '@superrb/gatsby-addons/components'
import {
  useEventListener,
  useIsInViewport,
  useIsMobile,
  useModal,
  useMotionAllowed,
} from '@superrb/gatsby-addons/hooks'
import { ImageLayout } from '@superrb/gatsby-addons/types'
import ReactPlayer from 'react-player'
import Underline from '../underline'

const Video = ({
  url,
  playing,
  muted = true,
  controls = false,
  playsinline = true,
  className = '',
  onError = () => {},
}: {
  url: string
  playing: boolean
  muted?: boolean
  controls?: boolean
  playsinline?: boolean
  className?: string
  onError?: () => void
}) => (
  <div className={`hero__video ${className}`} aria-hidden={!playing}>
    <ReactPlayer
      className={`hero__video-player`}
      url={url}
      width="100%"
      height="100%"
      playing={playing}
      playsinline={playsinline}
      autoPlay={true}
      loop={true}
      muted={muted}
      onError={onError}
      controls={controls}
    />
  </div>
)

const Hero = ({
  uid,
  data: {
    title,
    subtitle,
    button_label,
    mobile_image,
    desktop_image,
    mobile_video,
    desktop_video,
  },
}: HomepageSectionHero) => {
  const { isInViewport, setRef } = useIsInViewport(false)
  const isMotionAllowed = useMotionAllowed()
  const isMobile = useIsMobile(true)
  const [playing, setPlaying] = useState<boolean>(false)
  const [muted, setMuted] = useState<boolean>(true)
  const [previewPlaying, setPreviewPlaying] = useState<boolean>(true)

  const { isOpen, openModal } = useModal('trailer')

  useEffect(() => {
    setPlaying(isOpen)
    setPreviewPlaying(!isOpen)
  }, [isOpen])

  const image = isMobile ? mobile_image : desktop_image
  const video = isMobile ? mobile_video : desktop_video

  useEventListener(
    'click',
    (event) => {
      setPlaying(false)
      setPreviewPlaying(true)
      event.preventDefault()
    },
    { passive: true },
    typeof document !== 'undefined' ? document : undefined,
    playing,
  )

  return (
    <section
      className="hero"
      aria-label="title"
      id={uid}
      ref={setRef}
      onClick={(event) => event.stopPropagation()}
    >
      <div className="hero__background">
        {image && (
          <Image
            className="hero__background-image"
            image={image}
            layout={ImageLayout.cover}
            preload={true}
            aria-hidden={!!previewPlaying}
          />
        )}

        {video?.preview && (
          <Video
            className="hero__preview-video"
            url={video.preview}
            playing={previewPlaying && isMotionAllowed && isInViewport}
            onError={() => setPreviewPlaying(false)}
          />
        )}
        {video?.main && (
          <>
            <div className="modal-wrapper" aria-hidden={!isOpen}>
              <Modal name="trailer" className="hero__modal">
                <Video
                  className="hero__video"
                  url={video.main}
                  playing={playing && isMotionAllowed && isInViewport}
                  muted={muted}
                  controls={true}
                  playsinline={false}
                />
              </Modal>
            </div>
          </>
        )}
      </div>

      <div className="hero__container container">
        <div className="hero__content">
          <h1 className="hero__title">
            <span className="screenreader-text">{title}</span>
            <Logo />
          </h1>

          {video?.preview && video?.main && (
            <nav className="hero__nav">
              <span className="hero__subtitle">{subtitle}</span>
              {/*<button*/}
              {/*  className="hero__play"*/}
              {/*  onClick={() => {*/}
              {/*    openModal()*/}
              {/*    setPlaying(true)*/}
              {/*  }}*/}
              {/*>*/}
              {/*  {button_label}*/}
              {/*  <Underline style={1} className="hero__play-underline" />*/}
              {/*</button>*/}
            </nav>
          )}
        </div>
      </div>
    </section>
  )
}

export default Hero
